export default "__VITE_ASSET__HVmkqryM__"